import {
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react'
import axios, { AxiosResponse } from 'axios'

import { useJHireURL } from '../../../contexts/Domain'

export interface ApplicationDetailsResponse {
    application: {
        EId: string
        agencyApp: boolean
        applicationStatus: string
        applicationStatusKind: string
        sourceTypeName: string
        lastUpdate: number
        job: {
            EId: string
            title: string
            requisitionId: string
        }
        workflowStateEId: string
    }
    applicationWorkflowActions: Array<any>
    applicationWorkflowSteps: Array<any>
    applicationRankScore:  Array<any>
}

export interface ApplicationDetailsProps {
    applicationId: string
}
export default function useApplicationDetails({
    applicationId,
}: ApplicationDetailsProps) {
    const JHIRE_URL = useJHireURL()

    const mountedRef = useRef(true)
    let { current: mounted } = mountedRef
    const networkCounterRef = useRef(0)

    const [fetching, setFetching] = useState(true)
    const [error, setError] = useState('')
    const [data, setData] = useState<ApplicationDetailsResponse>()

    const fetchApplications = () => {
        setFetching(true)
        setError('')
        const currentCount = networkCounterRef.current + 1
        networkCounterRef.current += 1

        try {
            axios.get(`${JHIRE_URL}/action/application/${applicationId}/details?applicationId=${applicationId}&readMode=1`)
                .then((response: AxiosResponse<ApplicationDetailsResponse>) => {
                    if (mounted && currentCount === networkCounterRef.current) {
                        setData(response.data)
                        setFetching(false)
                        setError('')
                    }
                })
                .catch((error) => {
                    if (mounted && currentCount === networkCounterRef.current) {
                        setFetching(false)
                        setError('An error occurred while fetching applications')
                    }
                    console.log(error)
                })
        } catch(error) {
            if (mounted && currentCount === networkCounterRef.current) {
                setFetching(false)
                setError('An error occurred while fetching applications')
            }
            console.log(error)
        }
    }

    useEffect(() => {
        if (mounted && applicationId) {
            fetchApplications()
        }
    }, [applicationId])

    useEffect(() => {
        mounted = true

        return () => {
            mounted = false
        }
    }, [])

    return useMemo(() => ({
        data,
        isLoading: fetching,
        error,
    }), [
        data,
        fetching,
        error,
    ])
}